// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2eZcU","select":"Header_select__3hGnD","clinic":"Header_clinic__1xO0-"};